import { render } from "./ButtonDouble.vue?vue&type=template&id=8ffdc004&scoped=true"
import script from "./ButtonDouble.vue?vue&type=script&lang=js"
export * from "./ButtonDouble.vue?vue&type=script&lang=js"

import "./ButtonDouble.vue?vue&type=style&index=0&id=8ffdc004&scoped=scoped&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ffdc004"]])

export default __exports__